module.exports = __webpack_public_path__ + "static/media/Evolution.3d2abb96.png";